//#region src/components/SourceTabs/SourceTabs.module.css
var e = "_container_engmw_1", t = "_hint_engmw_8", n = "_tabs_engmw_16", r = "_titles_engmw_21", i = "_tabContent_engmw_29", a = {
	container: e,
	hint: t,
	tabs: n,
	titles: r,
	tabContent: i
};
//#endregion
export { e as container, a as default, t as hint, i as tabContent, n as tabs, r as titles };
